import React from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Tasks from "../components/Tasks/Tasks";

export default function Home() {
  return (
    <>
      <div className="container relative">
        <Sidebar />
        <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
          <Tasks />
        </div>
      </div>
    </>
  );
}
